import {Component, Object3D, property, Type} from '@wonderlandengine/api';

import {State} from './classes/gameState.js';
import {storageSpace13} from './globals.js';
import {LevelGenerator} from './level-generator.js';

export class HandleTitleState extends Component {
    static TypeName = 'handle-title-state';

    @property.object({required: true})
    levelGenObject!: Object3D;

    generated: boolean;
    camPos: number[];
    originalPlayerPosition: number[];
    wasPaused: boolean;

    start() {
        storageSpace13.gameState.changeOnProperty('state').add((state) => {
            if (state === State.Title) {
                let pos = this.object.getPositionWorld([]);
                if (!this.generated) {
                    let result = this.levelGenObject.getComponent(LevelGenerator).generate('Title', this.object);
                    this.generated = true;
                    this.camPos = result.cameraPosition;
                }
                this.originalPlayerPosition = [...storageSpace13.gameState.playerPosition];
                storageSpace13.gameState.playerPosition = [this.camPos[0], pos[1], this.camPos[2]];
                //this.wasPaused = state === State.Pause;
            }
            if (state !== State.Title && state !== State.Pause) {
                //  this.object.setTranslationWorld([0,-10000,0]);
                // if(this.wasPaused){
                //     StorageSpace13.gameState.playerPosition=this.originalPlayerPosition;
                // }
            }
        });
    }
}
